import type { DepartmentAncestor } from "../types";

interface BreadcrumbItem {
	label: string;
	id?: string;
	collapsed?: DepartmentAncestor[];
}

/** Bo'lim bo'g'inlari (ajdodlar + joriy bo'lim) shu songa yetganda yig'iladi. */
const COLLAPSE_FROM_SEGMENTS = 4;

/**
 * Spec §8: bo'lim bo'g'inlari (ajdodlar + joriy bo'lim) 4 va undan ko'p
 * bo'lsa — BIRINCHI + "…" (yashiringan o'rtadagilar, hover'da ko'rinadi) +
 * OXIRGI IKKITASI. Oxirgi ikkitasi — ota-bo'lim va JORIY bo'lim; joriyni
 * iste'molchi (`DepartmentProfileHeader`) qo'shadi, ya'ni bu funksiya oxirgi
 * AJDODNI qoldiradi. «Bo'limlar» ildiz havolasi bo'g'in sanog'iga KIRMAYDI.
 *
 * Ya'ni: 2 yoki kamroq ajdod — yig'ilmaydi; 3 ajdod (chuqurlik 4) —
 * `[A, …(B), C]`; 4 ajdod — `[A, …(B, C), D]`.
 *
 * ⚠️ Chegara va «yashiringan bo'g'in bor» sharti BIR XIL shart: yig'ilganda
 * `collapsed` DOIM kamida bitta ajdodni oladi. Bo'sh "…" (hech narsani
 * yashirmaydigan, zanjirga bo'g'in QO'SHADIGAN) hech qachon qaytmaydi —
 * iste'molchi natijani filtrlamasdan chizadi (`breadcrumb.test.ts` pinlaydi).
 */
export function collapseAncestors(ancestors: DepartmentAncestor[]): BreadcrumbItem[] {
	const first = ancestors[0];
	const last = ancestors[ancestors.length - 1];
	const hidden = ancestors.slice(1, -1);

	if (ancestors.length + 1 < COLLAPSE_FROM_SEGMENTS || !first || !last || hidden.length === 0) {
		return ancestors.map((a) => ({ label: a.name, id: a.id }));
	}

	return [
		{ label: first.name, id: first.id },
		{ label: "…", collapsed: hidden },
		{ label: last.name, id: last.id },
	];
}
